import React, { ButtonHTMLAttributes } from 'react'

import * as S from './styles'

export type ButtonTypes = ButtonHTMLAttributes<HTMLButtonElement>

export type ButtonProps = {
  children: React.ReactNode
  endIcon?: React.ReactElement
  Thisclass?:string
} & ButtonTypes

const Button = ({
  Thisclass,
  children,
  endIcon,
  ...props
}: ButtonProps) => (
  <S.Wrapper
    className={Thisclass}
    {...props}
  >
    {children}
    {endIcon}
  </S.Wrapper>
)

export default Button
